document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('[data-toggle="dropdown"]').forEach(function (element) {
		element.addEventListener('click', function () {
			const isActive = element.parentNode.classList.contains('dropdown--active');
			document.querySelectorAll('.dropdown--active').forEach(function (element) {
				element.classList.remove('dropdown--active');
			});
			if(isActive) {
				element.parentNode.classList.remove('dropdown--active');
			} else {
				element.parentNode.classList.add('dropdown--active');
			}
		});
	});
});